export default {
  path: '/cash',
  meta: {
    title: '服务费',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/cash`),
}



// WEBPACK FOOTER //
// ./src/views/cash/router.js